import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { supabase } from '../utils/supabaseClient';

export default function AcceptOrg() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const [status, setStatus] = useState('checking'); // checking | need-auth | working | done | error
  const [msg, setMsg] = useState('');

  useEffect(() => {
    (async () => {
      const token = sp.get('token');
      if (!token) { setStatus('error'); setMsg('Missing invite token.'); return; }

      const { data: { session } } = await supabase.auth.getSession();
      if (!session) { setStatus('need-auth'); return; }

      try {
        setStatus('working');
        await api.post('/org/invite/accept', { token });
        setStatus('done');
        setTimeout(() => nav('/profile'), 800);
      } catch (e) {
        setStatus('error');
        setMsg(e?.response?.data?.error || e.message || 'Could not accept invite.');
      }
    })();
  }, [sp, nav]);

  const shell =
    'mx-auto max-w-md mt-24 glass-card p-6 text-slate-200';

  return (
    <div className="px-6">
      <div className={shell}>
        <h1 className="mb-2 text-xl font-semibold">
          <span className="bg-gradient-to-r from-amber-200 to-amber-500 bg-clip-text text-transparent">
            Accept Invitation
          </span>
        </h1>

        {status === 'checking' && <p>Checking...</p>}
        {status === 'need-auth' && (
          <div>
            <p className="mb-3 text-zinc-300">Please sign in to accept this invitation.</p>
            <a href="/" className="underline">Go to sign in</a>
          </div>
        )}
        {status === 'working' && <p>Joining company...</p>}
        {status === 'done' && <p>Success! Redirecting to your profile...</p>}
        {status === 'error' && (
          <div className="text-red-400">
            {msg || 'Something went wrong.'}{' '}
            <button onClick={() => window.location.reload()} className="underline">Try again</button>
          </div>
        )}
      </div>
    </div>
  );
}
